const VERSION = import.meta.env.VITE_VERSION ?? 'N/A';
const IS_DEV = import.meta.env.DEV;

export { VERSION, IS_DEV };
